import { Parallax } from '../../plugins/gsap/parallax';

const heroes = document.querySelectorAll('.pane--hero-work');

heroes.forEach((hero) => {
    new Parallax(hero);
});
